/* eslint-disable @typescript-eslint/ban-types */
import { Shard } from "../shard";
export class PersistShard extends Shard {
    constructor({ initialValue, fallback, key }) {
        super(initialValue);
        this.getKey = () => this.key;
        this.getFallbackData = () => this.fallback;
        this.key = key;
        this.fallback = fallback;
    }
}
export const persist = (config) => {
    return new PersistShard(config);
};
//# sourceMappingURL=index.js.map